module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAFMandsAAAAAXNSR0IArs4c6QAAAQBJREFUOBGNUlsOgzAMo3zyv93/EtyA//0gcYdtN5imzu7itLAMiBTysp0W6HLOY9caGrmtT+UiIc5OUKFhh+SiKfKpNNiEr2iLIzUxlNOLDJq9NJBXcU5Rz3QtFIPLaNyxHgrJgbnAdS8GU8RET+BypklqbTTQGB6uUfiu4xo6FX6GkjUQb0OrB20AOtiiHmPPhzHuSK/wN+r6TjiE01wWuZ8pcUJmSumB6EYQipc3ogSggfv5NmmU9TURgT1iDIuAP0i2GYRiZzBFLwJGPS3fjUbUB0JZfr3Dq7roZjOFJBZe04lMNuQVYW9WRA4Bzaq/WAxGOD/z6Tub2A3xCR8+4mnls/QCogoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cross.png
// module id = PUL0
// module chunks = 1